import { Injectable, inject } from "@angular/core";
import { BaseServiceExt } from "@providers/BaseServiceExt";
import { DeviceService } from "@services/device.service";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class SportTrackPollingService extends BaseServiceExt {
  deviceService = inject(DeviceService);
  isDesktop: boolean;
  isMobile: boolean;

  homePolling$ = new BehaviorSubject(true);
  eventPolling$ = new BehaviorSubject(true);
  todayPolling$ = new BehaviorSubject(true);
  marketPolling$ = new BehaviorSubject(true);
  raceMarketPolling$ = new BehaviorSubject(true);
  livePolling$ = new BehaviorSubject(true);
  liveMarketPolling$ = new BehaviorSubject(true);

  pollings$ = [
    this.eventPolling$,
    this.homePolling$,
    this.livePolling$,
    this.liveMarketPolling$,
    this.marketPolling$,
    this.raceMarketPolling$,
    this.todayPolling$,
  ];

  constructor() {
    super();
    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();
  }

  // POLLING METHODS
  startHomePagePolling() {
    this.stopAllPollings();
    this.homePolling$.next(true);
  }

  startEventPagePolling() {
    this.stopAllPollings();
    this.eventPolling$.next(true);
  }

  startMarketPagePolling() {
    this.stopAllPollings();
    this.marketPolling$.next(true);
  }

  startTodayPagePolling() {
    this.stopAllPollings();
    this.todayPolling$.next(true);
  }

  startRaceMarketPagePolling() {
    this.stopAllPollings();
    this.raceMarketPolling$.next(true);
  }

  startLivePagePolling() {
    this.stopAllPollings();
    this.livePolling$.next(true);
  }

  startLiveMarketPagePolling() {
    this.stopAllPollings();
    this.liveMarketPolling$.next(true);
  }

  stopAllPollings() {
    this.pollings$.forEach((polling) => this.stopPolling(polling));
  }

  stopPolling(pollingSubject: BehaviorSubject<boolean>) {
    pollingSubject.next(false);
    pollingSubject.complete();
  }
}
